import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Observable, of } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { RangeFeature } from "src/app/model/catalog/catalog.model";
import { LensSide } from "src/app/model/configuration/configuration";
import { GlobalStorageService } from "src/app/service-utils/global-storage.service";
import { i18nService } from "src/app/service-utils/i18n.service";
import { ValidatorService } from "src/app/service-utils/validator-service";
import { NewOrderStoreService } from "../../new-order-store-service.service";

@Component({
    selector: 'app-new-parameter',
    templateUrl: './new-parameter.component.html',
    styleUrls: ['./new-parameter.component.scss']
})
export class NewParameterComponent implements OnInit {

    @Input() side: LensSide;
    @Input() originalMaterial: string[];

    form: FormGroup;

    filteredMaterial: Observable<string[]>;

    constructor(private formBuilder: FormBuilder,
                private i18nService: i18nService,
                private newOrderStoreService: NewOrderStoreService,
                private validatorService: ValidatorService,
                private globalStorageService: GlobalStorageService) {}

    ngOnInit(): void {
        this.filteredMaterial = of(this.originalMaterial);

        this.form = this.formBuilder.group({
            material: ["", [this.validatorService.requiredFieldValidator('Material')]],
            radiusBasecurve: ["", [this.validatorService.numericValidator('RadiusBasecurve'), this.validatorService.requiredFieldValidator('RadiusBasecurve'), this.validatorService.rangeValidator(new RangeFeature('RadiusBasecurve', true, 3, 15, 0.05))]],
            radiusBasecurve2: ["", [this.validatorService.numericValidator('RadiusBaseCurve2'), this.validatorService.requiredFieldValidator('RadiusBaseCurve2'), this.validatorService.rangeValidator(new RangeFeature('RadiusBaseCurve2', true, 3, 15, 0.05))]],
        });

        this.filteredMaterial = this.form.get('material').valueChanges.pipe(
            startWith(''),
            map(value => this.filterMaterial(value))
        );

        if(this.side === LensSide.RIGHT) {
            if(this.newOrderStoreService.radiusBasecurveTrialLensRight) {
                this.form.patchValue({'radiusBasecurve': this.newOrderStoreService.radiusBasecurveTrialLensRight});
                this.form.get('radiusBasecurve').markAsTouched();
                this.newOrderStoreService.radiusBasecurveTrialLensRight = {};
            }
            this.newOrderStoreService.radiusBasecurveTrialLensRight$.subscribe(radiusBasecurve => {
                if(radiusBasecurve) {
                    this.form.patchValue({'radiusBasecurve': radiusBasecurve});
                    this.form.get('radiusBasecurve').markAsTouched();
                    this.setValueWithFormat('RadiusBasecurve', 'radiusBasecurve');
                }
            });

            if(this.newOrderStoreService.radiusBasecurve2TrialLensRight) {
                this.form.patchValue({'radiusBasecurve2': this.newOrderStoreService.radiusBasecurve2TrialLensRight});
                this.form.get('radiusBasecurve2').markAsTouched();
                this.newOrderStoreService.radiusBasecurve2TrialLensRight = {};
            }
            this.newOrderStoreService.radiusBasecurve2TrialLensRight$.subscribe(radiusBasecurve2 => {
                if(radiusBasecurve2) {
                    this.form.patchValue({'radiusBasecurve2': radiusBasecurve2});
                    this.form.get('radiusBasecurve2').markAsTouched();
                    this.setValueWithFormat('RadiusBaseCurve2', 'radiusBasecurve2');
                }
            });

            if(this.newOrderStoreService.materialTrialLensRight && Object.keys(this.newOrderStoreService.materialTrialLensRight).length > 0) {
                this.form.patchValue({'material': this.newOrderStoreService.materialTrialLensRight});
                this.form.get('material').markAsTouched();
                this.newOrderStoreService.materialTrialLensRight = {};
            }
            this.newOrderStoreService.materialTrialLensRight$.subscribe(material => {
                if(material) {
                    this.form.patchValue({'material': material});
                    this.filteredMaterial = of(this.originalMaterial);
                }
            });

        } else if(this.side === LensSide.LEFT) {

            if(this.newOrderStoreService.radiusBasecurveTrialLensLeft) {
                this.form.patchValue({'radiusBasecurve': this.newOrderStoreService.radiusBasecurveTrialLensLeft});
                this.form.get('radiusBasecurve').markAsTouched();
                this.newOrderStoreService.radiusBasecurveTrialLensLeft = {};
            }
            this.newOrderStoreService.radiusBasecurveTrialLensLeft$.subscribe(radiusBasecurve => {
                if(radiusBasecurve) {
                    this.form.patchValue({'radiusBasecurve': radiusBasecurve});
                    this.form.get('radiusBasecurve').markAsTouched();
                    this.setValueWithFormat('RadiusBasecurve', 'radiusBasecurve');
                }
            });

            if(this.newOrderStoreService.radiusBasecurve2TrialLensLeft) {
                this.form.patchValue({'radiusBasecurve2': this.newOrderStoreService.radiusBasecurve2TrialLensLeft});
                this.form.get('radiusBasecurve2').markAsTouched();
                this.newOrderStoreService.radiusBasecurve2TrialLensLeft = {};
            }
            this.newOrderStoreService.radiusBasecurve2TrialLensLeft$.subscribe(radiusBasecurve2 => {
                if(radiusBasecurve2) {
                    this.form.patchValue({'radiusBasecurve2': radiusBasecurve2});
                    this.form.get('radiusBasecurve2').markAsTouched();
                    this.setValueWithFormat('RadiusBaseCurve2', 'radiusBasecurve2');
                }
            });

            if(this.newOrderStoreService.materialTrialLensLeft && Object.keys(this.newOrderStoreService.materialTrialLensLeft).length > 0) {
                this.form.patchValue({'material': this.newOrderStoreService.materialTrialLensLeft});
                this.form.get('material').markAsTouched();
                this.newOrderStoreService.materialTrialLensLeft = {};
            }
            this.newOrderStoreService.materialTrialLensLeft$.subscribe(material => {
                if(material) {
                    this.form.patchValue({'material': material});
                    this.filteredMaterial = of(this.originalMaterial);
                }
            });

        }
    }

    selectMaterial() {
        if(this.form.get('material').value === NONE) {
            this.form.get('material').setValue('');
        }
        this.filteredMaterial = of(this.originalMaterial);
    }

    checkRequiredFields() {

        Object.keys(this.form.controls).forEach(key => {
          if(this.form.controls[key].enabled && this.form.controls[key].value === '') {
            this.form.controls[key].markAsTouched();
            this.form.controls[key].setValue("");
          }
        });

    }

    private filterMaterial(value: string): string[] {
        if(value) {
            const filterValue = this.normalizeValue(value);
            return this.originalMaterial.filter(material => this.normalizeValue(material).includes(filterValue));
        } else {
            return this.originalMaterial;
        }
    }

    private normalizeValue(value: string): string {
        return value.toLowerCase().replace(/\s/g, '');
    }

    getLimitsFormatted(rangeMin: number, rangeMax: number) {
        return this.i18nService.getLimitsFormatted(rangeMin, rangeMax);
    }

    setValueWithFormat(featureName: string, control: string) {
        this.form.controls[control].setValue(
            this.i18nService.replaceFromDotToComma(
                this.i18nService.formatIfNumber(this.form.controls[control].value, this.globalStorageService.decimalFormats.find(feature => feature.featureName === featureName)?.decimalFormat)
            )
        );
    }
}

export const NONE = 'NONE';
